import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getProfilePicV } from './GraphHelpers';
/**
 * Get a user's avatar via the server photo endpoint (through GraphHelpers), with the existing
 * in-memory cache + dedup. No longer fetches a Microsoft Graph token — the endpoint resolves the
 * photo with the Teamflect session, and accepts the UPN or oid.
 * @param upn - User's userPrincipalName (or oid); the endpoint resolves either
 * @param dimensions - Picture dimensions (default: '96x96')
 * @param handleError - Optional error handler
 */ var getProfilePicWithOptimize = function getProfilePicWithOptimize(param) {
    var upn = param.upn, _param_dimensions = param.dimensions, dimensions = _param_dimensions === void 0 ? '96x96' : _param_dimensions, handleError = param.handleError, signal = param.signal;
    return _async_to_generator(function() {
        var e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!upn) return [
                        2,
                        ''
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getProfilePicV(upn, dimensions, {
                            signal: signal
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    handleError && handleError(e);
                    return [
                        2,
                        ''
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};
export default getProfilePicWithOptimize;
